import { createContext } from 'preact';
import { useContext, useState, useCallback } from 'preact/hooks';

const LegalDocumentModalContext = createContext(null);

export const LegalDocumentModalProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [documentType, setDocumentType] = useState('terms'); // 'terms' or 'privacy'

    const openModal = useCallback((type) => {
        setDocumentType(type);
        setIsOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsOpen(false);
    }, []);

    const value = {
        isOpen,
        documentType,
        openModal,
        closeModal
    };

    return (
        <LegalDocumentModalContext.Provider value={value}>
            {children}
        </LegalDocumentModalContext.Provider>
    );
};

export const useLegalDocumentModal = () => {
    const context = useContext(LegalDocumentModalContext);
    if (!context) {
        throw new Error('useLegalDocumentModal must be used within LegalDocumentModalProvider');
    }
    return context;
};
